module.exports = __webpack_public_path__ + "img/gymbk-logo.3a8263bb.png";